var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ArchivedTasks',{attrs:{"scope":"DDO"}})
}
var staticRenderFns = []

export { render, staticRenderFns }